import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Section/layouts/BTLuxe/+types/BTLuxePage";
import { fetchBTLuxePageData } from "@routes/Section/layouts/BTLuxe/BTLuxePage.server";
import BTLuxePageContent from "@routes/Section/layouts/BTLuxe/BTLuxePageContent";
import { BTLuxePageContext } from "@routes/Section/layouts/BTLuxe/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /keywords/:keyword route. */
const BTLuxePage = (): React.ReactElement => {
  const context = useLoaderData<BTLuxePageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <BTLuxePageContent {...context.payload.data} />;
};

export default BTLuxePage;

export const loader = async () => await fetchBTLuxePageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as BTLuxePageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: BTLuxePageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
